import { storageCache } from '@services/cache';
import { KEYS } from '@services/cache/constants';

// For tracking purposes
function setLocationPointSelectionType(selectionType) {
  return storageCache.set(KEYS.LOCATION_SELECTION_TYPE, selectionType);
}

export default setLocationPointSelectionType;
